/* wwp-variant-popup.js — Choose Options popup
   Triggered by [data-wwp-vp-handle] buttons (set in card-product.liquid)
   Shows: images, title, price, variant pills, Add to Bag, trust strip, link to product
*/
(function(){
  if(window.wwpVP)return; window.wwpVP=true;
  var CORAL='#E0948F',TAN='#CA9365',CHARCOAL='#2B2926',CREAM='#FFFDFB';
  var root=(window.Shopify&&Shopify.routes&&Shopify.routes.root)||'/';
  var cache={};

  var S=document.createElement('style');
  S.textContent=[
    '#wwp-vp-ov{display:none;position:fixed;inset:0;background:rgba(43,41,38,.55);z-index:99990;align-items:flex-end;justify-content:center;}',
    '@media(min-width:640px){#wwp-vp-ov{align-items:center;}}',
    '#wwp-vp-ov.is-open{display:flex;}',
    '#wwp-vp{background:'+CREAM+';width:100%;max-width:440px;border-radius:20px 20px 0 0;max-height:94vh;overflow-y:auto;padding:20px 18px 28px;position:relative;box-shadow:0 -8px 40px rgba(0,0,0,.18);}',
    '@media(min-width:640px){#wwp-vp{border-radius:20px;}}',
    '#wwp-vp-close{position:absolute;top:14px;right:14px;background:none;border:none;font-size:22px;cursor:pointer;color:'+CHARCOAL+';padding:4px 8px;}',
    '.vp-imgs{position:relative;width:100%;aspect-ratio:1;border-radius:14px;overflow:hidden;background:#F5EFE6;margin-bottom:14px;}',
    '.vp-imgs__track{display:flex;overflow-x:auto;scroll-snap-type:x mandatory;scrollbar-width:none;height:100%;}',
    '.vp-imgs__track::-webkit-scrollbar{display:none;}',
    '.vp-imgs__slide{flex:0 0 100%;scroll-snap-align:start;}',
    '.vp-imgs__slide img{width:100%;height:100%;object-fit:cover;display:block;}',
    '.vp-imgs__nav{position:absolute;top:50%;transform:translateY(-50%);width:28px;height:28px;border-radius:50%;background:rgba(255,253,251,.9);border:none;display:flex;align-items:center;justify-content:center;cursor:pointer;box-shadow:0 1px 4px rgba(0,0,0,.15);}',
    '.vp-imgs__prev{left:8px;}.vp-imgs__next{right:8px;}',
    '.vp-imgs__dots{position:absolute;bottom:8px;left:50%;transform:translateX(-50%);display:flex;gap:5px;}',
    '.vp-imgs__dot{width:6px;height:6px;border-radius:50%;background:rgba(255,253,251,.5);border:none;padding:0;cursor:pointer;}',
    '.vp-imgs__dot.is-on{background:'+CORAL+';width:14px;border-radius:3px;}',
    '.vp-title{font-family:Poppins,sans-serif;font-size:16px;font-weight:700;color:'+CHARCOAL+';margin:0 0 4px;line-height:1.3;}',
    '.vp-price{font-size:15px;font-weight:700;color:'+CORAL+';margin:0 0 14px;}',
    '.vp-opt-label{font-size:11px;font-weight:700;text-transform:uppercase;letter-spacing:.06em;color:'+TAN+';margin:0 0 7px;display:block;}',
    '.vp-pills{display:flex;flex-wrap:wrap;gap:7px;margin-bottom:14px;}',
    '.vp-pill{padding:7px 14px;border-radius:40px;border:1.5px solid #E0DDD8;background:'+CREAM+';font-size:13px;font-weight:600;color:'+CHARCOAL+';cursor:pointer;transition:all .15s;font-family:Montserrat,sans-serif;}',
    '.vp-pill.is-active{background:'+CORAL+';border-color:'+CORAL+';color:'+CHARCOAL+';}',
    '.vp-pill.is-unavail{opacity:.4;cursor:not-allowed;text-decoration:line-through;}',
    '.vp-atb{display:flex;align-items:center;justify-content:center;gap:8px;width:100%;padding:14px;border-radius:40px;background:'+CORAL+';border:none;color:'+CHARCOAL+';font-family:Montserrat,sans-serif;font-size:14px;font-weight:700;cursor:pointer;margin-bottom:10px;transition:background .18s;}',
    '.vp-atb:hover{background:#C97970;color:'+CREAM+';}',
    '.vp-atb:disabled{opacity:.5;cursor:not-allowed;}',
    '.vp-trust{display:flex;gap:4px 12px;flex-wrap:wrap;justify-content:center;padding:10px 0;border-top:1px solid #F0EBE6;border-bottom:1px solid #F0EBE6;margin-bottom:12px;}',
    '.vp-trust span{display:flex;align-items:center;gap:4px;font-size:11.5px;font-weight:500;color:#6E665F;}',
    '.vp-trust svg{width:13px;height:13px;stroke:'+TAN+';fill:none;stroke-width:1.8;stroke-linecap:round;stroke-linejoin:round;flex-shrink:0;}',
    '.vp-more{display:block;text-align:center;font-size:12.5px;font-weight:600;color:'+TAN+';text-decoration:underline;margin-top:2px;}',
    '.vp-loading{display:flex;align-items:center;justify-content:center;padding:40px 20px;color:#B7AFA8;font-size:13px;}'
  ].join('');
  document.head.appendChild(S);

  var ov=document.createElement('div');
  ov.id='wwp-vp-ov';
  ov.setAttribute('role','dialog');
  ov.setAttribute('aria-modal','true');
  ov.innerHTML='<div id="wwp-vp"><button id="wwp-vp-close">&times;</button><div id="wwp-vp-body"><div class="vp-loading">Loading&hellip;</div></div></div>';
  document.body.appendChild(ov);
  var vpBody=document.getElementById('wwp-vp-body');

  function close(){ov.classList.remove('is-open');document.body.style.overflow='';}
  document.getElementById('wwp-vp-close').addEventListener('click',close);
  ov.addEventListener('click',function(e){if(e.target===ov)close();});
  document.addEventListener('keydown',function(e){if(e.key==='Escape')close();});

  function get(handle){
    if(!cache[handle])cache[handle]=fetch(root+'products/'+handle+'.js').then(function(r){return r.ok?r.json():null;}).catch(function(){return null;});
    return cache[handle];
  }

  function open(handle){
    vpBody.innerHTML='<div class="vp-loading">Loading&hellip;</div>';
    ov.classList.add('is-open');
    document.body.style.overflow='hidden';
    get(handle).then(function(p){if(p)render(p);else vpBody.innerHTML='<div class="vp-loading">Could not load.</div>';});
  }

  function esc(s){return String(s==null?'':s).replace(/&/g,'&amp;').replace(/</g,'&lt;').replace(/>/g,'&gt;').replace(/"/g,'&quot;');}

  function render(p){
    var imgs=p.images||[],variants=p.variants||[],options=p.options||[];
    var hasOpts=options.length>1||(options.length===1&&options[0].name!=='Title');
    var cur=variants.find(function(v){return v.available;})||variants[0];

    /* Image carousel */
    var iH='';
    if(imgs.length){
      iH='<div class="vp-imgs">';
      if(imgs.length>1)iH+='<button class="vp-imgs__nav vp-imgs__prev">&#8249;</button><button class="vp-imgs__nav vp-imgs__next">&#8250;</button>';
      iH+='<div class="vp-imgs__track">';
      imgs.slice(0,8).forEach(function(u,i){var s=u.src||u;if(s.indexOf('//')==0)s='https:'+s;iH+='<div class="vp-imgs__slide"><img src="'+s+'?width=500" alt="'+esc(p.title)+'" loading="'+(i?'lazy':'eager')+'"></div>';});
      iH+='</div>';
      if(imgs.length>1)iH+='<div class="vp-imgs__dots">'+imgs.slice(0,8).map(function(u,i){return'<button class="vp-imgs__dot'+(i===0?' is-on':'')+' " data-vi="'+i+'"></button>';}).join('')+'</div>';
      iH+='</div>';
    }

    /* Options */
    var oH='';
    if(hasOpts){
      options.forEach(function(opt){
        oH+='<span class="vp-opt-label">'+esc(opt.name)+'</span><div class="vp-pills" data-opt="'+esc(opt.name)+'">';
        opt.values.forEach(function(val){
          var avail=variants.some(function(v){return(v.option1===val||v.option2===val||v.option3===val)&&v.available;});
          var sel=cur&&(cur.option1===val||cur.option2===val||cur.option3===val);
          oH+='<button class="vp-pill'+(sel?' is-active':'')+(avail?'':' is-unavail')+'" data-val="'+esc(val)+'">'+esc(val)+'</button>';
        });
        oH+='</div>';
      });
    }

    var price=cur?('\u00a3'+parseFloat(cur.price/100).toFixed(2)):'';
    var trust='<div class="vp-trust">'+
      '<span><svg viewBox="0 0 24 24"><rect x="1" y="7" width="15" height="11"/><path d="M16 10h4l3 3v5h-7z"/><circle cx="6.5" cy="20" r="1.8"/><circle cx="18.5" cy="20" r="1.8"/></svg>Tracked delivery</span>'+
      '<span><svg viewBox="0 0 24 24"><path d="M3 10h11a5 5 0 010 10H9"/><path d="M7 6L3 10l4 4"/></svg>30-day returns</span>'+
      '<span><svg viewBox="0 0 24 24"><rect x="3" y="11" width="18" height="11" rx="2"/><path d="M7 11V7a5 5 0 0110 0v4"/></svg>Secure checkout</span>'+
    '</div>';

    vpBody.innerHTML=iH+
      '<h2 class="vp-title">'+esc(p.title)+'</h2>'+
      '<p class="vp-price" id="vp-pr">'+price+'</p>'+
      oH+
      '<input type="hidden" id="vp-vid" value="'+(cur?cur.id:'')+'">'+
      '<button class="vp-atb" id="vp-atb" '+(cur&&cur.available?'':'disabled')+'><svg viewBox="0 0 24 24" width="16" height="16" fill="none" stroke="currentColor" stroke-width="2"><path d="M6 2L3 6v14a2 2 0 002 2h14a2 2 0 002-2V6l-3-4z"/><line x1="3" y1="6" x2="21" y2="6"/><path d="M16 10a4 4 0 01-8 0"/></svg><span id="vp-atb-l">'+(cur&&cur.available?'Add to Bag':'Sold out')+'</span></button>'+
      trust+
      '<a href="'+esc(root+'products/'+p.handle)+'" class="vp-more">View all product information</a>';

    /* Image carousel controls */
    var track=vpBody.querySelector('.vp-imgs__track');
    if(track){
      var iDots=vpBody.querySelectorAll('.vp-imgs__dot'),iCur=0;
      function iGo(n){iCur=(n+imgs.length)%imgs.length;track.scrollTo({left:iCur*track.clientWidth,behavior:'smooth'});iDots.forEach(function(d,i){d.classList.toggle('is-on',i===iCur);});}
      var pB=vpBody.querySelector('.vp-imgs__prev'),nB=vpBody.querySelector('.vp-imgs__next');
      if(pB)pB.addEventListener('click',function(){iGo(iCur-1);});
      if(nB)nB.addEventListener('click',function(){iGo(iCur+1);});
      iDots.forEach(function(d){d.addEventListener('click',function(){iGo(parseInt(d.dataset.vi,10));});});
    }

    /* Variant pills */
    vpBody.addEventListener('click',function(e){
      var pill=e.target.closest('.vp-pill');
      if(!pill||pill.classList.contains('is-unavail'))return;
      pill.closest('[data-opt]').querySelectorAll('.vp-pill').forEach(function(p2){p2.classList.remove('is-active');});
      pill.classList.add('is-active');
      var sel={};
      vpBody.querySelectorAll('[data-opt]').forEach(function(g){var a=g.querySelector('.vp-pill.is-active');if(a)sel[g.dataset.opt]=a.dataset.val;});
      var match=variants.find(function(v){return options.every(function(o,i){return !sel[o.name]||v['option'+(i+1)]===sel[o.name];});})||variants[0];
      document.getElementById('vp-vid').value=match?match.id:'';
      var pr=document.getElementById('vp-pr');if(pr&&match)pr.textContent='\u00a3'+parseFloat(match.price/100).toFixed(2);
      var atb=document.getElementById('vp-atb'),lbl=document.getElementById('vp-atb-l');
      if(atb&&match){atb.disabled=!match.available;if(lbl)lbl.textContent=match.available?'Add to Bag':'Sold out';}
    });

    /* Add to Bag */
    document.getElementById('vp-atb').addEventListener('click',function(){
      var vid=parseInt(document.getElementById('vp-vid').value,10);
      if(!vid)return;
      var b=document.getElementById('vp-atb'),l=document.getElementById('vp-atb-l');
      b.disabled=true;if(l)l.textContent='Adding\u2026';
      fetch(root+'cart/add.js',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({items:[{id:vid,quantity:1}]})})
        .then(function(r){return r.json();})
        .then(function(res){
          var item=res.items&&res.items[0];
          close();
          if(item)document.dispatchEvent(new CustomEvent('wwpItemAdded',{detail:{title:item.product_title||item.title,price:(item.price/100).toFixed(2),image:item.featured_image?item.featured_image.url:(item.image||''),productId:item.product_id}}));
          fetch('/cart.js').then(function(r){return r.json();}).then(function(c){
            document.querySelectorAll('[data-cart-count],[data-cart-item-count],.cart-count-bubble span,.cart-count-bubble').forEach(function(el){el.textContent=c.item_count;});
          });
        })
        .catch(function(){var b2=document.getElementById('vp-atb'),l2=document.getElementById('vp-atb-l');if(b2){b2.disabled=false;if(l2)l2.textContent='Try again';}});
    });
  }

  /* ── Intercept Choose Options buttons ── */
  document.addEventListener('click',function(e){
    var btn=e.target.closest('[data-wwp-vp-handle]');
    if(!btn)return;
    e.preventDefault();
    e.stopPropagation();
    open(btn.getAttribute('data-wwp-vp-handle'));
  });

})();
